import React from 'react'
import PropTypes from 'prop-types'
import Collapsible from 'react-collapsible'

import { LessThanBreakpoint } from 'Utils/GetBreakpoint'
import Icon from 'Pods/Shared/Icon/Icon'

import SearchBar from './SearchBar'
import FiltersBar from './FiltersBar'
import ActiveFiltersBar from './ActiveFiltersBar'

class SearchForm extends React.Component {
  renderFiltersBar() {
    return (
      <FiltersBar
        onFiltersChange={this.props.onFiltersChange}
        onSortChange={this.props.onSortChange}
        filters={this.props.filters}
        availableSkillOptions={this.props.meta.availableSkillOptions}
        availableSoftwareOptions={this.props.meta.availableSoftwareOptions}
      />
    )
  }

  renderTrigger(message, icon) {
    return (
      <div className="projects-designers-list__trigger-wrapper">
        <button className="btn btn-outline-default">
          <Icon type={icon} />
          {message}
        </button>
      </div>
    )
  }

  render() {
    const {
      filters,
      meta,
      onSearch,
      onSearchFilterChange,
      onFiltersChange,
      resetFilters,
    } = this.props

    const googleMapsApiKey = typeof window !== 'undefined' ? window.App?.config?.googleMapsApiKey : undefined

    const isResetVisible = filters.software.length > 0
      || filters.skills.length > 0
      || filters.keywords.length > 0
      || filters.isOpenForHire

    return (
      <div className="designer-list__search-form">
        <Collapsible
          className="Collapsible--transparent projects-designers-list__filters"
          openedClassName="Collapsible--transparent projects-designers-list__filters is-opened"
          overflowWhenOpen="visible"
          transitionTime={300}
          open={false}
          trigger={this.renderTrigger('Show filters', ['far', 'filter'])}
          triggerWhenOpen={this.renderTrigger('Hide filters', ['fas', 'times'])}
        >
          <div className="designers-list__search-form-container">
            <div className="designer-list__search-bar-wrapper">
              <SearchBar
                onSearch={onSearch}
                onSearchFilterChange={onSearchFilterChange}
                keywords={filters.keywords}
                googleMapsApiKey={googleMapsApiKey}
              />
            </div>
            <div className="designer-list__filters-wrapper">
              {this.renderFiltersBar()}
            </div>
          </div>
        </Collapsible>
        <div className="active-filters__section--scrollable">
          {isResetVisible && (
            <span
              className="active-filters__reset-filters heading-24"
              onClick={resetFilters}
            >
              <Icon type={['fal', 'times-circle']} />
              <span className="active-filters__reset-filters-text heading-16">Clear all</span>
            </span>
          )}
          <ActiveFiltersBar
            onFiltersChange={onFiltersChange}
            filters={filters}
            availableSkillOptions={meta.availableSkillOptions}
            availableSoftwareOptions={meta.availableSoftwareOptions}
          />
        </div>
      </div>
    )
  }
}

SearchForm.propTypes = {
  filters: PropTypes.shape({
    skills: PropTypes.array.isRequired,
    keywords: PropTypes.string.isRequired,
    isOpenForHire: PropTypes.bool.isRequired,
  }).isRequired,
  meta: PropTypes.object.isRequired,
  onSearch: PropTypes.func.isRequired,
  onFiltersChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
}

export default SearchForm
